import React from 'react'
import Websocket from 'react-websocket'
import {WS_URL} from '../../api'
import {Badge, ListGroupItem} from 'reactstrap'
import HistoryIcon from 'react-icons/lib/fa/history'

let ControllerRegisterationListItem = ({controller, token, handleWebSocketResponse}) => {
    return <ListGroupItem>
        {(controller.online ?
            <Badge color="success" pill>Online</Badge> :
            <Badge color="danger" pill>Offline</Badge>)}
        &emsp;

        <strong>Phone&nbsp;Number:&ensp;</strong>
        {controller.serialNumber}
        &ensp;&mdash;&ensp;
        { controller && controller.team && controller.team.name ?
            <span>
                {controller.team.name}
                &ensp;&ensp;
            </span>:
                null}

        {(controller.legacyAccess ?
            <Badge color="warning"><HistoryIcon/>&nbsp;Legacy&nbsp;Software</Badge>
            : null)}

        {(controller.clockErrorActive || controller.clockErrors ?
            (controller.clockErrors && controller.clockErrors > 0 ?
                <Badge color="warning"><HistoryIcon/>&nbsp;{controller.clockErrors}&nbsp;Clock&nbsp;Errors</Badge> :
                <Badge color="warning"><HistoryIcon/>&nbsp;Clock&nbsp;Error</Badge>)
            : null)}
        &emsp;&emsp;

        {(token ?
            <Websocket url={`${WS_URL}/controllers/${controller.id}/?access_token=${token.accessToken}`}
                       onMessage={handleWebSocketResponse}/> :
            null)}
    </ListGroupItem>
}

export default ControllerRegisterationListItem



// WEBPACK FOOTER //
// ./src/components/ui/ControllerRegistrationListItem.js